import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import IOldLoginForm from './old.loginform.interface';
import TrackingService from '@/core/tracking.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'OldLoginForm',
  props: {
    initialsText: null,
    userNameText: null,
    passwordText: null,
    loginButtonText: null,
    showSpinner: { type: Boolean },
    loginErrorMessage: null,
    userMigratedText: null
  },
  emits: ['login'],
  setup(__props: any, { emit }) {



const formData = ref<IOldLoginForm>({
    initials: null,
    userName: null,
    password: null
});


const handleSubmit = () => {
    emit('login', formData.value);
    TrackingService.event('Login', 'Submit');
};

return { __sfc: true,formData, emit, handleSubmit }
}

})